<template>
    <div class="map-parent">

        <div>
            <div style="display:flex; flex-direction:row;">
                <p style="margin-right:16px;">From</p>
                <input
                    id="startDate"
                    type="date"
                    class="date"
                    v-model="startDate"
                    style="height:25px; width:200px; margin-right:16px;"/>
                <p style="margin-right:16px;">To</p>
                <input
                    id="endDate"
                    type="date"
                    class="date"
                    v-model="endDate"
                    style="height:25px; width:200px; margin-right:16px;"/>
                <p style="margin-right:16px; margin-bottom:0px;">Employee</p>
                <autocomplete
                    id="employeeSearch"
                    v-model="employeeSearch"
                    :type="28"
                    v-on:finish="setData"
                    style="width:200px; height:30px; margin-right:16px;">
                </autocomplete>
                <button style="height:30px;" v-on:click="search">Display</button>
                <button style="height:30px; margin-left:10px;" v-on:click="searchAll">View Active</button>
            </div>
        </div>

        <l-map
        ref="map"
        style="width: 100%; height: 100%; margin-top:16px; z-index: 1;"
        :zoom="zoom"
        :center="center">
            <l-marker v-for="(marker, i) in markers" :key="i" :lat-lng="marker.latlng" :icon="marker.icon">
                <l-popup class="popup">
                    {{marker.user}}<br>
                    {{marker.timestamp}}<br>
                    {{marker.comments}}
                </l-popup>
            </l-marker>
            <l-polyline  v-for="polyline in polylines" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
            <l-tile-layer :url="url"></l-tile-layer>
        </l-map>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
import L from 'leaflet';
import {LMap, LTileLayer, LMarker, LPolyline, LPopup} from 'vue2-leaflet';

export default {
    props: {
		term: ''
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
    },
	data(){
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 12,
            center: [33.7538924,-118.2421587],
            markers: [],
            lines: [],
            polylines: [],

            pageid:PAGES.TIMESHEET_MAP_PAGE,
            employeeSearch:"",
            startDate:"",
            endDate:"",
            showAllMode: false,
        };
	},
    methods: {
        makeLabelIcon(name, offsetY = 0) {
            return L.divIcon({
                html: `<div style="position:relative;width:0;height:0;"><div class="emp-dot"></div><span class="emp-label" style="position:absolute;left:14px;top:${offsetY}px;">${name}</span></div>`,
                className: '',
                iconSize: [0, 0],
                iconAnchor: [0, 0],
            });
        },
        setPolyLines () {
            this.polylines = []
            for (let i = 0;i < this.lines.length;i++) {
                this.polylines.push({
                    latlngs:[],
                    color: "blue"
                })
                for(let j = 0;j<this.lines[i].length;j++) {
                    this.polylines[i].latlngs.push(this.markers[this.lines[i][j]].latlng)
                }
            }
        },
        search() {
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid,
                        data:[
                            this.employeeSearch,
                            this.startDate,
                            this.endDate ? new Date(new Date(this.endDate).getTime() + 86400000).toISOString().slice(0,10) : this.endDate,
                        ],
                    }
                }
            ).then((res) => {
                let data = res.data.data.column_data;

                this.markers = []
                this.lines = []
                this.showAllMode = false

                if(data[0].length==0) {
                    return;
                }

                this.lines.push([])
                for(let i = 0;i<data.length;i++) {
                    let comment = data[i][5] +", "+data[i][6]
                    if(data[i][7]!=-1) comment += ", 11-"+data[i][7]
                    if(data[i][8]!=-1) comment += ", T-"+data[i][8]
                    
                    this.markers.push({
                        latlng: [data[i][2],data[i][3]],
                        user: data[i][4],
                        comments: comment
                    })

                    this.lines[0].push(i)
                }

                this.setPolyLines();
                this.$nextTick(() => {
                    this.$refs.map.mapObject.fitBounds(tempMarkers.map(m => m.latlng), { padding: [40, 40] });
                });
            })
        },
        searchAll(){
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid,
                        data:[
                            null,
                            null,
                            null,
                        ],
                    }
                }
            ).then((res) => {
                let data = res.data.data.column_data;

                this.markers = []
                this.lines = []
                this.showAllMode = true

                if(data[0].length==0) {
                    return;
                }

                const tempMarkers = [];
                for(let i = 0; i < data.length; i++) {
                    let comment = data[i][5] +", "+data[i][6]
                    if(data[i][7]!=-1) comment += ", 11-"+data[i][7]
                    if(data[i][8]!=-1) comment += ", T-"+data[i][8]
                    tempMarkers.push({
                        latlng: [data[i][2], data[i][3]],
                        user: data[i][4],
                        comments: comment,
                    });
                }

                const threshold = 0.005;
                for (let i = 0; i < tempMarkers.length; i++) {
                    let stackIndex = 0;
                    for (let j = 0; j < i; j++) {
                        const dlat = Math.abs(tempMarkers[i].latlng[0] - tempMarkers[j].latlng[0]);
                        const dlng = Math.abs(tempMarkers[i].latlng[1] - tempMarkers[j].latlng[1]);
                        if (dlat < threshold && dlng < threshold) stackIndex++;
                    }
                    tempMarkers[i].icon = this.makeLabelIcon(tempMarkers[i].user, stackIndex * 24);
                }

                this.markers = tempMarkers;
                this.setPolyLines();
                this.$nextTick(() => {
                    this.$refs.map.mapObject.fitBounds(tempMarkers.map(m => m.latlng), { padding: [40, 40] });
                });
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setPolyLines();
        })
    }
}
</script>

<style>

.emp-label {
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
    background: white;
    padding: 1px 5px;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.emp-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #2b7fe7;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.4);
    flex-shrink: 0;
    margin-right: 5px;
}


.map-parent {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 50px);
    width:100%;
    padding:16px;
}

.popup br {
    margin:5px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/view/Timesheet_Map.vue